import React from "react";
export default class Constants extends React.Component {
  static TIPO_INSCRIPCION_IDS = {
    "Tradicional":0,
    "Simplificada":1
  };
}
